import React from 'react';
import PropTypes from 'prop-types';
import { Buy4Pay3 } from './product/buy_4_pay_3';
import { featureFlags } from '../../../../_constants/feature_flags';

export function ProductSetPriceBuy4Pay3(props) {
    const { buy4pay3 } = props;
    const discountPrice = (Math.floor(props.quantity / 4) * props.pricePerItem);
    const productBuy4Pay3SetPriceRows = [];


    if (featureFlags.FEATURE_TYRE_DEALS && buy4pay3) {
        productBuy4Pay3SetPriceRows.push(
            <Buy4Pay3
                discount={discountPrice}
                currencyIsoCode={props.currencyIsoCode}
                key="Buy4Pay3"
            />
        );
    }

    return productBuy4Pay3SetPriceRows;
}

ProductSetPriceBuy4Pay3.propTypes = {
    buy4pay3: PropTypes.bool.isRequired,
    quantity: PropTypes.number.isRequired,
    pricePerItem: PropTypes.number.isRequired,
    setPrice: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
};
